/**
 * Shared SignalWire configuration constants.
 *
 * The space host is the FQDN of the SignalWire Fabric space and is required
 * by the browser SDK when initialising a client (`SignalWire({ host })`).
 */
export const SIGNALWIRE_SPACE_HOST = "decoda.signalwire.com";

// Browser calls are usually bridged to PSTN, so prefer non-Opus telephony
// codecs before Opus. The SignalWire SDK reorders SDP codec priority; it does
// not remove fallback codecs from the browser offer.
export const SIGNALWIRE_PSTN_AUDIO_CODECS = ["G722", "PCMU", "PCMA"];

export function applyPstnAudioCodecPreference(client: {
  preferences: { preferredAudioCodecs: string[] };
}) {
  client.preferences.preferredAudioCodecs = [...SIGNALWIRE_PSTN_AUDIO_CODECS];
}
